export enum EventLocations {
    Location = 'Location',
    Room = "Room",
    Wing = "Wing",
    Building = "Building",
    Other = "Other"
}